import React, { useEffect, useRef, useState } from 'react';
import CustomText from '../../../Common/customComponents/CustomText.tsx';
import { commonMsg, companyUtil, dateUtil, systemCdUtil } from '../../../../utils/globalUtil.tsx';
import CustomButton from '../../../Common/customComponents/CustomButton.tsx';

import CustomSelectSingle from '../../../Common/customComponents/CustomSelectSingle.tsx';
import FormApproval from './approval/FormApproval.tsx';
import CustomTextarea from '../../../Common/customComponents/CustomTextarea.tsx';
import PermitIssueForm from './PermitIssueForm.tsx';
import CustomDate from '../../../Common/customComponents/CustomDate.tsx';
import { ptwApi } from '../../../../api/ptw.api.ts';
import { safObjectHelper } from 'utils/SafObjectHelper.ts';
import PermitIssueMap from './PermitIssueMap.tsx';
import { useUser } from 'hooks/useUser.ts';
import CustomRadioSingle from 'containers/Common/customComponents/CustomRadioSingle.tsx';
import { useAsync } from 'hooks/useAsync.ts';
import OperatorModal from '../modal/OperatorModal.tsx';
import FormTabXBlack from '/assets/icon/global/form-tab-x-black.svg';
import WorkLocationModal from '../modal/WorkLocationModal.tsx';
import { codeApi } from '../../../../api/code.api.ts';
import DashIcon from '/assets/icon/global/cancel.svg';
import ClockIcon from '/assets/icon/global/extension.svg';
import ActionClock from '/assets/icon/global/action-clock.svg';
import ExtensionHistoryModal from '../modal/ExtensionHistoryModal.tsx';

interface IProps {
  data: any;
  setData: any;
  handleChange: any;
  formCode: string;
  isReadOnly: boolean;
  mainPermitData: any;
  isFinish: boolean;
}

const Form06ExcavationDetail = (props: IProps) => {
  const { callAsync, showAlarm, closeAlarm } = useAsync();
  const [isOperatorModalOpen, setIsOperatorModalOpen] = useState<boolean>(false);
  const [isWorkLocationModalOpen, setIsWorkLocationModalOpen] = useState<boolean>(false);
  const [isExtHistoryModalOpen, setIsExtHistoryModalOpen] = useState<boolean>(false);
  const [selectedUserList, setSelectedUserList] = useState<any>([]);
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const gubun = useRef<string>('');
  /*공통코드*/
  const [disciplineCdList, setDisciplineCdList] = useState<any>([]);
  const [workCdList, setWorkCdList] = useState<any>([]);
  const [taskCdList, setTaskCdList] = useState<any>([]);
  const [companyList, setCompanyList] = useState<any>([]);
  const user = useUser();

  useEffect(() => {
    codeApi.getDiscpCodeList().then((list) => {
      setDisciplineCdList(list);
      setWorkCdList([]);
      setTaskCdList([]);
    });
    companyUtil.getOptions().then((list) => {
      setCompanyList(list);
    });
  }, []);
  useEffect(() => {
    codeApi.getDiscpCodeList(props.data?.disciplineCd).then((list) => {
      setWorkCdList(list);
      setTaskCdList([]);
    });
  }, [props.data?.disciplineCd]);

  useEffect(() => {
    codeApi.getDiscpCodeList(props.data?.workCd).then((list) => {
      setTaskCdList(list);
    });
  }, [props.data?.workCd]);

  useEffect(() => {
    if (!props.data || Object.keys(props.data).length === 0) {
      props.setData((prev: any) => ({
        ...prev,
        workRisk: 'HIGH',
        excavation: 'manual'
      }));
    }
  }, [props.data]);

  const onActionUserSearchCallback = (checkedList: any[]) => {
    if (!checkedList) return;
    props.handleChange({
      target: {
        name: gubun.current,
        value: checkedList.length > 0 ? checkedList.map((v: any) => String(v.userNm)) : null
      }
    });

    commonMsg.alert(showAlarm, closeAlarm, 'Success', 'It has been Added.', null);
  };

  const deletePerformAuthorityItem = (item: string) => {
    const updated = (props.data?.performAuthorityList ?? []).filter((i: string) => i !== item);

    if (props.handleChange) {
      props.handleChange({
        target: {
          name: 'performAuthority',
          value: updated
        }
      });
    }
  };

  const workLocationCallback = (location: any, locationText: any) => {
    props.handleChange({
      target: {
        name: 'location',
        value: location,
        type: 'json'
      }
    });
    props.handleChange({
      target: {
        name: 'locationText',
        value: locationText
      }
    });
    setIsWorkLocationModalOpen(false);
  };

  return (
    <>
      <WorkLocationModal
        setIsModalOpen={setIsWorkLocationModalOpen}
        isModalOpen={isWorkLocationModalOpen}
        onActionCallback={workLocationCallback}
        location={props.data?.location}
        locationText={props.data?.locationText}
      />
      <OperatorModal
        setIsModalOpen={setIsOperatorModalOpen}
        isModalOpen={isOperatorModalOpen}
        title={'Operator'}
        onActionCallback={onActionUserSearchCallback}
        selectedList={selectedUserList}
        searchKeyword={searchKeyword}
      />
      <div className={'cold-detail'}>
        {props.mainPermitData?.approvalStatus === 'CANCEL' && (
          <div className="cancel-area">
            <img src={DashIcon} alt="ban icon" className="cancel-icon" />
            <div className="cancel-content-area">
              <div className="cancel-title">
                <span className="cancel-title-text">Permit Cancelled</span>
              </div>
              <div className="cancel-content">
                <div className="cancel-content-detail">
                  <span className="cancel-content-name">{props.mainPermitData?.cancellerNm}</span>
                  <span>·</span>
                  <span className="cancel-content-comment">
                    {props.mainPermitData?.cancelComment}
                  </span>
                </div>
                <div className="cancel-date">
                  <img src={ActionClock} alt="ban icon" className="action-icon" />
                  <span>{dateUtil.formatDate(props.mainPermitData?.cancelDate)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {props.mainPermitData?.extendDate && (
          <div className="extend-area">
            <ExtensionHistoryModal
              isModalOpen={isExtHistoryModalOpen}
              setIsModalOpen={setIsExtHistoryModalOpen}
              ptwDSeq={props.mainPermitData?.ptwDSeq}
            />
            <img src={ClockIcon} alt="ban icon" className="extend-icon" />
            <div className="extend-content-area">
              <div className="extend-title">
                <span className="extend-title-text">Extension Approved</span>
                <button
                  className="extend-history-btn"
                  onClick={() => setIsExtHistoryModalOpen(true)}
                >
                  EXTENSION HISTORY
                </button>
              </div>
              <div className="extend-content">
                <div className="extend-content-detail">
                  <span className="extend-content-name">{props.mainPermitData?.extenderNm}</span>
                  <span>·</span>
                  <span className="extend-content-comment">{props.mainPermitData?.comment}</span>
                </div>
                <div className="extend-date">
                  <img src={ActionClock} alt="ban icon" className="action-icon" />
                  <span>{dateUtil.formatDate(props.mainPermitData?.extendDate)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className={'contents-watermark-wrapper'}>
          <div
            className={
              'form-contents ' +
              (props.mainPermitData?.approvalStatus === 'CANCEL' ? 'form-cancel-watermark' : '')
            }
          >
            {/* renew로 생성시킨 데이터 */}
            {props.data?.refPtwDSeq && (
              <>
                <div className={'form-sub-title'}>Renewal Reference</div>
                <table className={'form-table'}>
                  <tbody>
                    <tr>
                      <th className={'form-required'} style={{ width: '300px' }}>
                        Renewed from Permit No
                      </th>
                      <td>
                        <CustomText
                          onChange={props.handleChange}
                          name={'refPtwNo'}
                          className={'form'}
                          readOnly={true}
                          value={props.data?.refPtwNo}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            )}
            <table className={'form-table'}>
              <tbody>
                <tr>
                  <th style={{ width: '300px' }}>ECC No</th>
                  <td>
                    <CustomText
                      onChange={props.handleChange}
                      name={'ptwNo'}
                      className={'form'}
                      readOnly={true}
                      value={props.data?.ptwNo}
                    />
                  </td>
                </tr>
                <tr>
                  <th>PTW No</th>
                  <td>
                    <CustomText
                      name={'eccNumber'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.eccNumber}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className={'form-sub-title'}>Work Requisition & Description</div>
            <table className={'form-table'}>
              <tbody>
                <tr>
                  <th>
                    <div>
                      Task Description <br />& Excavation Dimension
                    </div>
                    <div className={'header-title-mini'}>(Length x Width x Depth)</div>
                  </th>
                  <td>
                    <CustomTextarea
                      name={'description'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.description}
                      disabled={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '300px' }}>Work Risk</th>
                  <td>
                    <div className={'flex-row flex-row-center gap-2'}>
                      {props.data?.workRisk === 'GENERAL' && (
                        <CustomButton
                          text={'General Work'}
                          className={'grid-button blue cursor-none'}
                        />
                      )}
                      {props.data?.workRisk === 'HIGH' && (
                        <CustomButton
                          text={'High-Risk Work'}
                          className={'form-button red cursor-none'}
                        />
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Work Location / Area</th>
                  <td>
                    <div className={'group-td-column'}>
                      <CustomText
                        name={'locationText'}
                        className={'form'}
                        value={props.data?.locationText}
                        isBtnSearch={!props.isReadOnly}
                        onSearchAction={() => {
                          setIsWorkLocationModalOpen(true);
                        }}
                        readOnly={true}
                      />
                      <PermitIssueMap location={props.data?.location} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Company</th>
                  <td>
                    <CustomSelectSingle
                      name={'companyId'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.companyId}
                      options={companyList}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Register</th>
                  <td>
                    <CustomText
                      name={'receiverNm'}
                      className={'form'}
                      readOnly={true}
                      value={props.data?.receiverNm}
                      defaultValue={user.userInfo?.fullName}
                      onChange={props.handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Sub Contractor</th>
                  <td>
                    <CustomText
                      name={'subcontractor'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.subcontractor}
                      readOnly={true}
                      defaultValue={user.userInfo?.companyName}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Date of Issue</th>
                  <td>
                    <CustomDate
                      name={'permitDate'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.permitDate}
                      disabled={true}
                      defaultValue={new Date()}
                    />
                  </td>
                </tr>

                <tr>
                  <th>Method of Excavation</th>
                  <td>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                      <CustomRadioSingle
                        name={'excavation'}
                        value="manual"
                        onChange={props.handleChange}
                        label="Manual"
                        selectedValue={props.data?.excavation}
                      />
                      <CustomRadioSingle
                        name={'excavation'}
                        value="mechanical"
                        onChange={props.handleChange}
                        label="Mechanical"
                        selectedValue={props.data?.excavation}
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>Excavator No</th>
                  <td>
                    <CustomText
                      name={'excavatorNo'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.excavatorNo}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Performing Authority</th>
                  <td>
                    <CustomText
                      onChange={props.handleChange}
                      name={'performAuthority'}
                      className={'form'}
                      value={(props.data?.performAuthority ?? []).join(',')}
                      readOnly={true}
                      isBtnSearch={!props.isReadOnly}
                      onSearchAction={() => {
                        gubun.current = 'performAuthority';
                        setIsOperatorModalOpen(true);
                      }}
                    />
                    <div className="work-select-multi">
                      {props.data?.performAuthority?.map((item: string, index: number) => (
                        <div className="selected-item" key={index}>
                          <span>{item}</span>

                          {!props.isReadOnly && (
                            <a onClick={() => deletePerformAuthorityItem(item)}>
                              <img
                                src={FormTabXBlack}
                                alt="close"
                                style={{ width: '15px', height: '15px' }}
                              />
                            </a>
                          )}
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <PermitIssueForm
              formCode={props.formCode}
              handleChange={props.handleChange}
              data={props.data}
              isReadOnly={props.isReadOnly}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Form06ExcavationDetail;
